import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { ConversationTitleUpdatedMessage } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import type { Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';

const isConversationTitleUpdatedMessage = (
	message: unknown,
): message is ConversationTitleUpdatedMessage =>
	typeof message === 'object' &&
	message !== null &&
	'type' in message &&
	message.type === 'CONVERSATION_TITLE_UPDATED' &&
	'conversation_id' in message &&
	typeof message.conversation_id === 'string' &&
	'name' in message &&
	typeof message.name === 'string';

export const processConversationTitleUpdated = (
	streamMessage: unknown,
	conversationId: string,
	updateConversation: (data: Partial<Conversation>) => void,
): boolean => {
	if (
		!isConversationTitleUpdatedMessage(streamMessage) ||
		!fg('rovo_chat_live_conversation_titles')
	) {
		return false;
	}

	const name = streamMessage.name.trim();
	if (streamMessage.conversation_id === conversationId && name) {
		updateConversation({ name });
	}
	return true;
};
